module.exports = __webpack_public_path__ + "img/A.mo.9e94a570.jpg";